// @ts-nocheck
class AsyncUtils {
  static async executeAll(promises) {
    const results = await Promise.allSettled(promises);
    const rejected = results.filter(result => result.status === 'rejected');
    if (rejected[0]) {
      throw new Error(rejected[0].reason);
    }
    return results;
  }
}

export default AsyncUtils;
